import { connect } from 'react-redux';
import { closePanel } from '../../actions/panel';
import {
  load, update, reset, save, dismissStatus
} from '../../actions/hangings';
import { hangingPreview } from '../../selectors/preview';
import { workSizeDetails, hangingVariations } from '../../selectors/work_sizes';
import Hanging from './hanging';

const mapStateToProps = (state) => ({
  worksExtended: workSizeDetails(state),
  ...hangingPreview(state),
  hangingVariations: hangingVariations(state),
  ...state.hangings,
  wallHeight: state.canvas.height
});

export default connect(mapStateToProps, {
  closePanel, load, update, reset, save, dismissStatus
})(Hanging);
